import { useState } from "preact/hooks";

import { exportJson, exportCsv, exportHtml, exportHighlightsMarkdown } from "../lib/export";

export function ExportPanel() {
  const [busy, setBusy] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const run = async (kind: "json" | "csv" | "html" | "md") => {
    setBusy(kind);
    setError(null);
    try {
      if (kind === "json") await exportJson();
      else if (kind === "csv") await exportCsv();
      else if (kind === "html") await exportHtml();
      else await exportHighlightsMarkdown();
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setBusy(null);
    }
  };

  return (
    <>
      {error && <div class="banner error">{error}</div>}
      <div class="col">
        <div class="row" style="flex-wrap: wrap;">
          <button onClick={() => run("json")} disabled={!!busy}>
            {busy === "json" ? <span class="spinner" /> : "Export JSON"}
          </button>
          <button onClick={() => run("csv")} disabled={!!busy}>
            {busy === "csv" ? <span class="spinner" /> : "Export CSV"}
          </button>
          <button onClick={() => run("html")} disabled={!!busy}>
            {busy === "html" ? <span class="spinner" /> : "Export HTML"}
          </button>
          <button onClick={() => run("md")} disabled={!!busy}>
            {busy === "md" ? <span class="spinner" /> : "Highlights Markdown"}
          </button>
        </div>
        <p class="subtle" style="font-size: var(--fs-12);">
          JSON and CSV include articles, tags, and highlights. HTML is self-contained
          and readable in any browser. Markdown is highlights only.
        </p>
      </div>
    </>
  );
}
